module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-open_new-green-0042abd8.svg";